import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaGoogle } from 'react-icons/fa';

const LoginLogout = () => {
  const { currentUser, loginWithGoogle, logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setError(null); // Clear previous errors
    try {
      await loginWithGoogle();
      navigate('/profile');
    } catch (err) {
      console.error("Firebase Login Error:", err);
      let friendlyMessage = "Giriş sırasında bilinmeyen bir hata oluştu.";
      switch (err.code) {
        case 'auth/popup-closed-by-user':
          friendlyMessage = "Giriş penceresini kapattınız. Lütfen tekrar deneyin.";
          break;
        case 'auth/cancelled-popup-request':
          friendlyMessage = "Giriş işlemi iptal edildi.";
          break;
        case 'auth/popup-blocked-by-browser':
          friendlyMessage = "Giriş penceresi tarayıcınız tarafından engellendi. Lütfen tarayıcı ayarlarınızdan pop-up'lara izin verin.";
          break;
        case 'auth/network-request-failed':
          friendlyMessage = "Ağ bağlantısı hatası. Lütfen internet bağlantınızı kontrol edin.";
          break;
        default:
          friendlyMessage = `Bir hata oluştu. Lütfen daha sonra tekrar deneyin. (Kod: ${err.code})`;
      }
      setError(friendlyMessage);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error("Çıkış sırasında hata oluştu:", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-80px)] bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md p-8 space-y-8 bg-white dark:bg-gray-800 rounded-2xl shadow-xl">
        {currentUser ? (
          <div>
            <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white">Hoş Geldin!</h2>
            <p className="text-center text-gray-600 dark:text-gray-300 mt-2">{currentUser.email}</p>
            <button
              onClick={handleLogout}
              className="w-full flex justify-center items-center py-3 px-4 mt-6 text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-transform transform hover:scale-105"
            >
              Çıkış Yap
            </button>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white">Giriş Yap</h2>
            <p className="text-center text-gray-500 dark:text-gray-400 mt-2">Devam etmek için giriş yapın.</p>
            
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-md relative mt-4" role="alert">
                <span className="block sm:inline">{error}</span>
              </div>
            )}

            <button
              onClick={handleLogin}
              className="w-full flex justify-center items-center py-3 px-4 mt-8 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-transform transform hover:scale-105"
            >
              <FaGoogle className="mr-2" />
              Google ile Giriş Yap
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginLogout;